module.exports = "https://cdn.dove.it/_next/static/public/assets/landings/join-our-agents/marketing.2cba987bf91fad778b63fc6d72633c71.jpg";